/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';
var TwitchIcon = createIcon({
  name: 'TwitchIcon',
  height: 512,
  width: 448,
  svgPath: 'M40.1 32L10 108.9v314.3h107V480h60.2l56.8-56.8h87l117-117V32H40.1zm357.8 254.1L331 353H224l-56.8 56.8V353H76.9V72.1h321v214zM331 149v116.9h-40.1V149H331zm-107 0v116.9h-40.1V149H224z',
  yOffset: '',
  xOffset: '',
  transform: ''
});
export default TwitchIcon;